/**
 * Chemins des pages du site, centralisés.
 *
 * Les URL sont écrites **une seule fois** ici : renommer une page ne demande
 * alors qu'une modification, et un lien mort devient une erreur de compilation
 * plutôt qu'un 404 découvert en production.
 *
 * Attention aux deux chemins marqués « URL de retour » : ils sont transmis à
 * l'API (`return_url` du portail de facturation) ou figurent dans les emails
 * envoyés par la plateforme (lien de réinitialisation du mot de passe). Ils
 * doivent rester alignés avec ce qui est configuré côté site, sans quoi l'API
 * répond `422 invalid_redirect_url`.
 */
export const paths = {
    home: '/',
    search: '/recherche',
    // 🟢 1. La VRAIE fiche de l'entreprise (données complètes débloquées)
    company: (registrationNumber: string) => `/entreprise/${encodeURIComponent(registrationNumber)}`,
    companyPattern: '/entreprise/:registrationNumber',

    // 🟢 2. Le tunnel de paiement ciblé sur une entreprise
    buy: (registrationNumber: string) => `/paiement?entreprise=${encodeURIComponent(registrationNumber)}`,

    pricing: '/tarifs',
    checkout: '/paiement',
    checkoutSuccess: '/paiement/confirmation',
    login: '/connexion',
    forgotPassword: '/mot-de-passe-oublie',
    /** URL de retour : c'est la cible du lien envoyé par email. */
    resetPassword: '/reinitialiser-mot-de-passe',
    /** URL de retour : c'est là que le portail Stripe renvoie le client. */
    account: '/compte',
    cancelSubscription: '/resilier-mon-abonnement',
    newsletter: '/newsletter',
    unsubscribe: '/desinscription',
    contact: '/contact',
    legal: '/mentions-legales',
    terms: '/conditions-generales',
    privacy: '/confidentialite',
    /** Page réservée aux développeurs : le mode d'emploi de cet exemple. */
    services: '/services',
    entreprise: '/entreprise',
    resultat: '/resultat',
    download: '/resultat/download',

} as const;
